<template>
  <div>
    <div class="body" v-loading="isLoading">
      <el-table
        :header-cell-class-name="headerBackgroundColor"
        :row-class-name="rowClass"
        :data="data"
      >
        <el-table-column
          type="index"
          width="152px"
        >
          <template slot="header" slot-scope="scope">
            <div @onScope="scope" class="header-comp">序号</div>
          </template>
        </el-table-column>
        <el-table-column
          width="372px"
          label="标题"
          prop="title"
        >
        </el-table-column>
        <el-table-column
          width="372px"
          label="创建时间"
          prop="createTime"
        >
        </el-table-column>
        <el-table-column width="104px" label="操作">
          <template slot-scope="scope">
            <div class="operation-class">
              <el-popover
                placement="bottom"
                trigger="hover"
                content="下载简报"
                :visible-arrow=false>
                <div slot="reference" class="download-hover">
                  <a :href="scope.row.url"><i class="download"></i></a>
                </div>
              </el-popover>
              <el-popover
                placement="bottom"
                trigger="hover"
                content="删除简报"
                :visible-arrow=false>
                <div slot="reference" class="delete-hover">
                  <i class="delete" @click="onDeleteBtnClick(scope.row)"></i>
                </div>
              </el-popover>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pager" v-if="totalCount > 0">
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>
    <el-dialog
      title=''
      class="delete-dialog"
      :visible.sync="dialogVisible"
      width="524px"
      top="33vh"
    >
      <span class="dialog-delete-monitor">删除</span>
      <span class="dialog-company">{{this.title}}</span>
      <span class="dialog-delete-monitor">?</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onOKDeleteBtnClick()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import authService from '@/services/authService';
import questionQuery from '@/rest/questionQuery';

export default {
  data() {
    return {
      data: [],
      isLoading: false,
      dialogVisible: false,
      totalCount: 100,
      username: '',
      pageNum: 1,
      pageSize: 10,
      title: '',
      id: 0
    };
  },
  methods: {
    getBulletinList() {
      questionQuery.bulletinList(this.username, this.pageNum, this.pageSize).then(res => {
        this.totalCount = res.totalCount;
        this.data = res.pageItems;
      });
    },
    handleCurrentChange(page) {
      this.pageNum = page;
      this.getBulletinList();
    },
    headerBackgroundColor() {
      let tmp = null;
      tmp = 'header-pos-normal';
      return tmp;
    },
    rowClass() {
      return 'row-class';
    },
    onDeleteBtnClick(row) {
      this.dialogVisible = true;
      this.title = row.title;
      this.id = row.id;
    },
    onOKDeleteBtnClick() {
      questionQuery.deleteBulletin(this.id).then(
        () => {
          this.dialogVisible = false;
          this.getBulletinList();
        },
        () => {
          this.$message.error('取消监控失败！');
        }
      );
    }
  },
  mounted() {
    this.username = authService.getLoggedUserName();
    this.getBulletinList();
  }
};
</script>
<style lang="scss" scoped>
.body {
  min-height: 359px;
}
/deep/ .el-table_1_column_1 {
  padding-left: 6px;
}
/deep/ .el-table th div {
  height: 48px;
  line-height: 48px;
  padding-right: 2px;
}
.header-comp {
  margin-left: -10px;
}
.operation-class {
  display: flex;
  justify-content: space-around;
  margin-left: -13px;
  .download-hover {
    width: 24px;
    height: 24px;
    padding: 3px 4px 5px;
    &:hover {
      border-radius: 2px;
      background-color: #504d52;
    }
    &:active {
      border-radius: 2px;
      background-color: #605c61;
    }
    .download {
      display: inline-block;
      width: 16px;
      height: 16px;
      background-color: transparent;
      background-image: url("../../assets/img/download.svg");
      background-size: 100% 100%;
      cursor: pointer;
    }
  }
  .delete-hover {
    width: 24px;
    height: 24px;
    padding: 3px 4px 5px;
    &:hover {
      border-radius: 2px;
      background-color: #504d52;
    }
    &:active {
      border-radius: 2px;
      background-color: #605c61;
    }
    .delete {
      display: inline-block;
      width: 16px;
      height: 16px;
      background-color: transparent;
      background-image: url("../../assets/img/delete.svg");
      background-size: 100% 100%;
      cursor: pointer;
    }
  }
}
.dialog-delete-monitor {
  margin: 0 6px;
  color: #ffffff;
  font-size: 20px;
}
.dialog-company {
  color: #45a8cc;
  font-size: 20px;
}
.pager {
  display: flex;
  justify-content: center;
  height: 80px;
  margin-top: 26px;
  & /deep/ {
    .el-pagination {
      .el-pager li {
        min-width: 32px;
        height: 32px;
        line-height: 32px;
        margin: 0 0.125rem;
        color: #b3b2b3;
        font-family: "DIN-Regular";
        border-radius: 0;
        background: none;
        &.active {
          color: #fff;
          font-family: "DIN-Bold";
        }

        &:hover {
          border-radius: 54px;
          background-color: #333137;
        }
      }
      .el-input__inner {
        border: 0.0625rem solid #c2c2c2;
        border-radius: 0;
        &:focus {
          border: 0.0625rem solid #c2c2c2;
          border-radius: 0;
        }
      }
      .btn-prev,
      .btn-next {
        background: none;
        .el-icon-arrow-left:before {
          color: #fff;
        }
        .el-icon-arrow-right:before {
          color: #fff;
        }
        &:hover {
          border-radius: 54px;
          background-color: #333333;
          .el-icon-arrow-left:before {
            color: #e8e8e8;
          }
          .el-icon-arrow-right:before {
            color: #e8e8e8;
          }
        }
      }
      .btn-prev[class="btn-prev disabled"] {
        border-radius: 54px;
        background: none;
        .el-icon-arrow-left:before {
          color: #fff;
        }
      }
      .btn-next[class="btn-next disabled"] {
        border-radius: 54px;
        background: none;
        .el-icon-arrow-right:before {
          color: #fff;
        }
      }
      button {
        min-width: 32px;
        height: 32px;
        line-height: 32px;
        padding: 0;
      }
    }
  }
}
/deep/ .el-pagination span:not([class*="suffix"]),
.el-pagination button {
  height: 32px;
  color: #fff;
}
/deep/ .el-pagination__editor.el-input {
  .el-input__inner {
    width: 42px;
    height: 28px;
    color: #7a757b;
    border: solid 1px #4e4a4d;
    border-radius: 4px !important;
    background: none;
    &:hover {
      border: solid 1px #868285;
      background-color: #423f43;
    }

    &:active,
    &:focus {
      border: solid 1px #868285;
      color: #fff;
      background-color: #333137;
    }
  }
}

/deep/ {
  .header-pos-normal {
    height: 48px;
    padding: 0;
    font-size: 14px;
    color: #ffffff;
    background-color: #3b3a3f;
  }
  .row-class {
    height: 72px;
    background-color: #333138;
    color: #ffffff;
  }
  .el-table {
    background-color: #423f43;
  }
  .el-table::before {
    background-color: #565357;
  }
  .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: #423f43 !important;
  }
  .el-table td,
  .el-table th.is-leaf {
    border-bottom: 1px solid #27252a;
  }
  .el-table th.is-leaf {
    border-bottom: none;
  }
  .el-table__empty-block {
    background-color: #333138;
    .el-table__empty-text {
      color: #ffffff;
    }
  }
  .delete-dialog {
    .el-dialog {
      border-radius: 8px;
      background-color: #333138;
      box-shadow: 0px 29px 50px 0px rgba(5, 69, 92, 0.1);
      .el-dialog__headerbtn {
        top: 26px;
      }
      .el-dialog__header {
        padding: 0;
        .el-dialog__title {
          color: #ffffff;
        }
      }
      .el-dialog__body {
        padding: 32px 0 0 32px;
      }
      .el-dialog__footer {
        padding: 42px 32px 32px 0px;
      }
    }
  }
}
</style>

